import React from 'react';
import {
    Button,
    Menu,
    MenuItem,
    Avatar,
    Typography,
    Box,
    Divider,
    ListItemIcon,
    alpha,
} from '@mui/material';
import { AccountCircle, Logout, Person } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { authLogout } from '../store/actions/AuthAction';

interface iUserMenuNavBar {
    isAuthenticated: boolean;
    auth: any;
}

const UserMenuNavBar = (props: iUserMenuNavBar) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const dispatch = useDispatch();
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    if (!props.isAuthenticated) {
        return <React.Fragment />;
    }

    const logout = () => {
        setAnchorEl(null);
        dispatch(authLogout());
    };

    const username = props.auth.username || '';
    const initials = username
        .split(' ')
        .map((n: string) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2) || 'U';

    return (
        <React.Fragment>
            <Button
                onClick={handleClick}
                sx={{
                    color: '#fff',
                    textTransform: 'none',
                    borderRadius: 2,
                    px: 1.5,
                    py: 0.5,
                    minWidth: 'auto',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                        bgcolor: (theme) => alpha(theme.palette.common.white, 0.1),
                    },
                }}
            >
                <Avatar
                    sx={{
                        width: 32,
                        height: 32,
                        fontSize: '0.8rem',
                        fontWeight: 700,
                        bgcolor: (theme) => alpha(theme.palette.common.white, 0.2),
                        color: '#fff',
                        mr: 1,
                    }}
                >
                    {initials}
                </Avatar>
                <Typography
                    variant="body2"
                    sx={{
                        color: '#fff',
                        fontWeight: 500,
                        display: { xs: 'none', sm: 'block' },
                        maxWidth: 120,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {username}
                </Typography>
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                PaperProps={{
                    sx: {
                        minWidth: 200,
                        mt: 1,
                    },
                }}
            >
                <Box sx={{ px: 2, py: 1.5 }}>
                    <Typography variant="subtitle2" fontWeight={700}>
                        {username}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {props.auth.roleName || 'Usuario'}
                    </Typography>
                </Box>
                <Divider sx={{ my: 0.5 }} />
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <Person fontSize="small" />
                    </ListItemIcon>
                    Perfil
                </MenuItem>
                <MenuItem onClick={logout} sx={{ color: 'error.main' }}>
                    <ListItemIcon>
                        <Logout fontSize="small" sx={{ color: 'error.main' }} />
                    </ListItemIcon>
                    Sair
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

export default UserMenuNavBar;
